import { Flex, Group, Text, UnstyledButton } from "@mantine/core";
import SvgElement from "./SvgElement";
import { IconDotsVertical } from "@tabler/icons-react";

const BottomBar = () => {
  return (
    <>
      <Group
        style={{ padding: "0px 20px" }}
        className="poll-bottom-bar"
        justify="space-between"
      >
        <Group>
          <Group align="center" gap={19}>
            <Text fz="xs" c="dimmed">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  color: "#828282",
                }}
              >
                <SvgElement name="vote-icon-empty" /> {0}
              </div>
            </Text>

            <Text fz="xs">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  color: "#828282",
                }}
              >
                <SvgElement name="reply-icon" />
                {0}{" "}
              </div>
            </Text>
          </Group>
        </Group>
        <Group>
          <Flex gap={14}>
            <UnstyledButton>
              <SvgElement name="share-icon" />
            </UnstyledButton>
            <UnstyledButton>
              <IconDotsVertical
                color="#828282"
                size={18}
              />
            </UnstyledButton>
          </Flex>
        </Group>
      </Group>
    </>
  );
};

export default BottomBar;
